<template>
    <div>
        <footer class="px-3 px-md-6 px-lg-12 py-3 py-md-6 white--text footer" style="display:flex;justify-content:space-around">
            <v-row>
                <v-col cols="12" md="8" style="display:flex;flex-direction:row">
                    <v-col md="4">
                        <div>
                            <v-img :src="image_src" class="logo" :contain="true" width="150" max-width="250"></v-img>
                        </div>
                    </v-col>
                    <v-col md="4">
                        <div>
                            <h6 class="body-1 font-weight-bold mb-3">Nous joindre</h6>
                            <div class="body-2">
                              1460-1050, côte du Beaver Hall<br />
                              Montréal, QC H2Z 0A5<br />
                              <ul class="links">
                                <li>
                                  <a href="tel:(514) 281-9888" class="link"> (514) 281-9888 </a>
                                </li>
                                <li>
                                  <a href="mailto:oeaq@oeaq.qc.ca" class="link">oeaq@oeaq.qc.ca</a>
                                </li>
                              </ul>
                            </div>
                        </div>
                    </v-col>
                </v-col>
                <v-col cols="12" md="2">
                    <div>
                        <div class="d-fex flex-column">
                            <h6 class="body-1 font-weight-bold mb-3">Suivez-nous</h6>
                            <div class="flex-column" style="display:flex">
                                <v-btn text
                                       icon
                                       color="white"
                                       large
                                       link
                                       tile
                                       href="https://www.facebook.com/oeaq.qc.ca/?fref=ts/"
                                       title="Facebook">
                                    <v-icon>mdi-facebook</v-icon> Facebook
                                </v-btn>
                                <v-btn text
                                       icon
                                       color="white"
                                       large
                                       link
                                       tile
                                       href="https://fr.linkedin.com/company/ordre-des-%C3%A9valuateurs-agr%C3%A9%C3%A9s-du-qu%C3%A9bec"
                                       title="LinkedIn">
                                    <v-icon>mdi-linkedin</v-icon> LinkedIn
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" md="2">
                    <div>
                        <div class="d-fex flex-column">
                            <h6 class="body-1 font-weight-bold mb-3">Liens utiles</h6>
                            <div class="flex-column" style="display:flex">
                                <v-btn text
                                       icon
                                       color="white"
                                       large
                                       link
                                       tile
                                       href="https://oeaq.qc.ca/"
                                       title="Website">
                                    <v-icon>mdi-web</v-icon> OEAQ
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </footer>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                image_src: require("../assets/logo.png"),
            };
        },
    };
</script>

<style scoped>
    .links {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .link {
        color: white;
        text-decoration: none;
    }

    .link:hover {
        text-decoration: underline;
    }

    .footer {
        background-color: #58595b;
        color: white;
    }
</style>